var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
    
  var btnClass = "button.product-form__submit.button";
  var prodTitle = ".product__title h1";
  var prodPrice = ".price-container";

    
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"><p></p><div class="simple-product-price"></div><div class="st-reviews"></div></div></div><div class="simple-st-container__inner"><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('simple-st-container').length == 0){
  y[0].appendChild(sticky);
  
  
jQuery('.simple-product-name p').html(jQuery(prodTitle).eq(0).html());

setInterval(function(){ 
jQuery('.simple-product-price').eq(0).html(jQuery(prodPrice).html());
}, 1000);
  
 

  
jQuery('.simple-st-item__button').click(function(){
jQuery('.product-form__submit').eq(0).click()
});

  
 
    
};

       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("simple-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('simple-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('simple-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery(btnClass).eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   


  
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = ['https://cdn.shopify.com/s/files/1/0602/3767/6743/files/public_2.png?v=1722450465',
'https://cdn.shopify.com/s/files/1/0602/3767/6743/files/volunteer_activism.png?v=1722450464',  
'https://cdn.shopify.com/s/files/1/0602/3767/6743/files/workspace_premium.png?v=1722450465',
'https://cdn.shopify.com/s/files/1/0602/3767/6743/files/public_3.png?v=1722450465'
];
var badgeTexts = ["Worldwide Shipping",
                  "Handmade with Care",
                  "Premium Quality Acrylic",
                "Free 3M Strips"];
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.product-form__buttons')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container"><img src="' + imgSrcs[i] +  '"><span class="badge'+i+'">'+badgeTexts[i]+'</span></div>';
    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
}  
});                             
}

